import imageCompression from "browser-image-compression";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import { PDFDocument } from "pdf-lib";

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const IMAGE_OPTIONS = {
  maxSizeMB: 1,
  maxWidthOrHeight: 2000,
  useWebWorker: true,
  initialQuality: 0.8,
};

const PDF_OPTIONS = {
  renderScale: 2,
  maxDimension: 2000,
  jpegQuality: 0.7,
};

async function compressImage(file) {
  try {
    const out = await imageCompression(file, IMAGE_OPTIONS);
    return out.size < file.size ? new File([out], file.name, { type: out.type }) : file;
  } catch (err) {
    console.warn("image compression failed, using original:", err);
    return file;
  }
}

async function compressPdf(file) {
  try {
    const data = new Uint8Array(await file.arrayBuffer());
    const pdf = await pdfjsLib.getDocument({ data }).promise;
    const outPdf = await PDFDocument.create();

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const base = page.getViewport({ scale: 1 });
      const longest = Math.max(base.width, base.height);
      const scale = Math.min(PDF_OPTIONS.renderScale, PDF_OPTIONS.maxDimension / longest);
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement("canvas");
      canvas.width = Math.round(viewport.width);
      canvas.height = Math.round(viewport.height);
      const ctx = canvas.getContext("2d");

      await page.render({ canvasContext: ctx, viewport }).promise;

      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/jpeg", PDF_OPTIONS.jpegQuality)
      );
      if (!blob) continue;

      const bytes = new Uint8Array(await blob.arrayBuffer());
      const embedded = await outPdf.embedJpg(bytes);
      const newPage = outPdf.addPage([base.width, base.height]);
      newPage.drawImage(embedded, { x: 0, y: 0, width: base.width, height: base.height });
    }

    const outBytes = await outPdf.save();
    const compressed = new File([outBytes], file.name, { type: "application/pdf" });
    return compressed.size < file.size ? compressed : file;
  } catch (err) {
    console.warn("pdf compression failed, using original:", err);
    return file;
  }
}

export async function compressFile(file) {
  if (!file) return file;
  if (file.type && file.type.startsWith("image/")) return compressImage(file);
  if (file.type === "application/pdf") return compressPdf(file);
  return file;
}

export async function compressFiles(files) {
  return Promise.all(Array.from(files).map(compressFile));
}
